/* eslint-disable default-param-last */
/* eslint-disable sonarjs/default-param-last */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { hostname } from './util';

export const getReports = ({ limit = 100, page = 0, keywords }) => {
  const params = {
    limit,
    skip: limit ? page * limit : undefined,
  };

  if (keywords) {
    params.keywords = keywords;
  }

  return axios.get(`${hostname}/api/portal/reports`, { params }).then((resp) => {
    const reportItems = resp.data.results;
    const numberOfPages = Math.ceil(resp.data.count / limit);
    const reportTotalItems = resp.data.count;
    return { numberOfPages, reportItems, reportTotalItems };
  });
};

export const getReport = (id) =>
  axios.get(`${hostname}/api/portal/reports/${id}`).then((resp) => resp.data);

export const getCategories = () =>
  axios.get(`${hostname}/comms/projects/categories`).then((resp) => resp.data);

export const deleteAllReports = () => axios.post(`${hostname}/api/portal/reports/delete_all`);
